import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Mic, Brain, MessageCircle, Zap, Check } from "lucide-react";

const VoiceAIPage = () => {
  const features = [
    { icon: Brain, title: "Doğal Dil Anlama", desc: "Gelişmiş LLM modelleri ile müşterilerinizin ne dediğini sadece duymakla kalmaz, anlar ve bağlama uygun yanıt verir." },
    { icon: Mic, title: "İnsan Sıcaklığında Ses", desc: "Duygu tonlaması, duraksama ve vurgu gibi insansı konuşma özellikleriyle müşterileriniz AI ile konuştuğunu fark etmez." },
    { icon: Zap, title: "Düşük Gecikme", desc: "Optimize edilmiş STT → LLM → TTS pipeline'ımız sayesinde 500ms altında yanıt süresi." },
    { icon: MessageCircle, title: "30+ Dil Desteği", desc: "Türkçe, İngilizce, Almanca, Fransızca, Arapça ve daha fazlası. Aynı görüşmede dil değişimi mümkün." },
  ];

  const hero = (
    <PageHero
      eyebrow="Ürün"
      title="Sesli AI Ajan"
      subtitle="Müşterilerinizle doğal, akıcı ve insan sıcaklığında konuşan yapay zeka ajanları. 7/24 hizmet, sıfır bekleme süresi."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/blog/ai-voice-assistant.jpg" alt="Sesli AI ajan" height="380px" />
      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Neden Sesli AI?</h2>
            <p className="text-[15px] leading-relaxed max-w-2xl mx-auto" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Geleneksel çağrı merkezleri pahalıdır, ölçeklenemez ve insan hatasına açıktır. Sesli AI ajanları ile saniyeler içinde yüzlerce çağrıyı karşılayın, her müşteriye aynı kalitede hizmet verin.
            </p>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-5">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <f.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{f.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{f.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-12 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/customer-support.jpg"
                alt="Sesli AI müşteri hizmetleri"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "340px" }}
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-6xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Kullanım Alanları</h2>
            <div className="grid md:grid-cols-3 gap-5">
              {["Sipariş takibi ve durumu", "Randevu oluşturma / iptal", "SSS yanıtlama", "Şikayet kaydı ve takibi", "Bakiye ve hesap sorgulama", "Teknik destek ön eleme"].map((item) => (
                <div key={item} className="flex items-center gap-3 p-4 rounded-xl" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <Check size={16} style={{ color: "#10b981", flexShrink: 0 }} />
                  <span className="text-[14px] font-medium" style={{ color: "var(--fg)" }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6 text-center">
          <a
            href="https://app.verasist.ai"
            className="inline-block px-10 py-4 rounded-full font-bold text-[15px] transition-all duration-200"
            style={{ background: "var(--brand-navy)", color: "#fff" }}
          >
            Hemen Sesli Ajan Oluşturun
          </a>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default VoiceAIPage;
